import { DetailedHTMLProps, HTMLAttributes } from 'react'
import { FaCopy } from 'react-icons/fa'
import { Button } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { ColorsEnum, ColorsToneEnum } from 'types/cssTypes'
import { notificator } from 'utils/notificator/notificator'

interface IStyledProps {
  width?: string
}
interface IProps extends IStyledProps, Omit<DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>, 'ref'> {
  title?: string
  action?: boolean
  data?: any
}

export const SummaryCard = ({ title, children, width = '100%', ...props }: IProps) => {
  return (
    <Section width={width} {...props}>
      {title && (
        <header>
          {title}
          {props.action && (
            <Button
              variant="tertiary"
              size="small"
              radius="normal"
              onClick={() => {
                navigator.clipboard.writeText(props.data)
                notificator.notify({
                  heading: 'Summary copied to clipboard',
                  type: 'success',
                })
              }}
            >
              <FaCopy /> Copy Summary{' '}
            </Button>
          )}
        </header>
      )}
      <main>{children}</main>
    </Section>
  )
}

const Section = styled.section<IStyledProps>`
  border-radius: ${({ theme }) => theme.borderRadius.rounded};
  background-color: ${({ theme }) => theme.colors.neutral.lightest};
  border: 1px solid ${({ theme }) => theme.colors.grey.lighter};
  width: ${({ width }) => width};
  padding: 0.1rem;

  > header {
    color: ${({ theme }) => theme.colors.neutral.neutral};
    ${({ theme }) => theme.typography.m.medium};
    padding: ${({ theme }) => `${theme.spacing.xxs} ${theme.spacing.s}`};
    background-color: ${({ theme }) => theme.colors.neutral.lightest};
    border-bottom: ${({ theme }) => theme.borders.s.solid(ColorsEnum.grey, ColorsToneEnum.lighter)};

    display: flex;
    justify-content: space-between;
  }

  > main {
    padding: ${({ theme }) => `${theme.spacing.xxs} ${theme.spacing.s}`};
  }
`
